import list from './list'
import edit from './edit'
import icon from '@material-ui/icons/Person'

export default { list, edit, icon, options: { label: 'Modules' } }
